/* Shared by Popover, HoverCard and Combobox dropdowns. */
.dropdown {
    composes: dropdown from './Dropdown.module.css';
    --popover-border-color: var(--mantine-color-default-border);
    --popover-shadow: var(--mantine-shadow-md);
    /* Lightbox glass: translucent fill, blur + saturate, hairline highlight. */
    border-color: light-dark(rgb(255 255 255 / 65%), rgb(255 255 255 / 10%));
    background-color: light-dark(rgb(255 255 255 / 72%), rgb(30 31 34 / 72%));
    box-shadow:
        0 10px 32px rgb(0 0 0 / 12%),
        inset 0 1px 0 light-dark(rgb(255 255 255 / 70%), rgb(255 255 255 / 6%));
    -webkit-backdrop-filter: blur(16px) saturate(1.7);
    backdrop-filter: blur(16px) saturate(1.7);
}

@supports not (backdrop-filter: blur(1px)) {
    .dropdown {
        background-color: var(--mantine-color-body);
    }
}

@media (prefers-reduced-transparency: reduce) {
    .dropdown {
        background-color: var(--mantine-color-body);
        -webkit-backdrop-filter: none;
        backdrop-filter: none;
    }
}
